import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularDocument: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_document"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="document icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 30"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M2.4 0C1.07452 0 0 1.07452 0 2.4V21.6C0 22.9255 1.07452 24 2.4 24H17.6C18.9255 24 20 22.9255 20 21.6V9.57843C20 8.84908 19.7103 8.14961 19.1945 7.63388L12.2636 0.702944C11.8135 0.252856 11.2031 0 10.5665 0H2.4ZM1.5 2.4C1.5 1.90294 1.90294 1.5 2.4 1.5H10V8C10 9.10457 10.8954 10 12 10H18.5V21.6C18.5 22.0971 18.0971 22.5 17.6 22.5H2.4C1.90294 22.5 1.5 22.0971 1.5 21.6V2.4ZM17.9393 8.5H12C11.7239 8.5 11.5 8.27614 11.5 8V2.06066L17.9393 8.5Z" />
      </svg>
    </span>
  );
};

export { RegularDocument };
